;(function () {
  /* neverover — help-center UX.
     (A) Mobile: the category sidebar (.hs-sidebar-nav) becomes a native dropdown.
     (B) Help root, mobile: a small mono "Quick links" label above .ffaq-faqs. */
  if (window.__nvHelp) return;
  window.__nvHelp = true;

  var CHEV0 = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M9.5 7L14.5 12L9.5 17' stroke='black' stroke-width='1'/%3E%3C/svg%3E\")";
  var css =
    /* custom category dropdown (styled like the size variant selector) — must load on EVERY
       help page (category + article), not just the root, so it lives here. */
    '.nv-help-dd{ display:none; position:relative; margin:8px 0 18px; }' +
    '.nv-help-dd__toggle{ display:flex; align-items:center; justify-content:space-between; gap:12px; width:100%; background:#fff;' +
      'border:1px solid rgba(0,0,0,.15); border-radius:8px; padding:14px; font-size:1.4rem; color:#141416; cursor:pointer; text-align:left; }' +
    '.nv-help-dd__chev{ flex:0 0 auto; width:2rem; height:2rem; background-color:currentColor; display:inline-block;' +
      '-webkit-mask:' + CHEV0 + ' center/contain no-repeat; mask:' + CHEV0 + ' center/contain no-repeat;' +
      'transition:transform .2s ease; }' +
    '.nv-help-dd__panel{ position:absolute; top:calc(100% + 6px); left:0; right:0; background:#fff; border:1px solid rgba(0,0,0,.12);' +
      'border-radius:10px; box-shadow:0 12px 30px rgba(20,20,22,.12); overflow:hidden; z-index:60; display:none; }' +
    '.nv-help-dd__opt{ display:block; width:100%; text-align:left; background:#fff; border:0; border-bottom:1px solid rgba(0,0,0,.06);' +
      'padding:14px 16px; font-size:1.4rem; color:#141416; cursor:pointer; }' +
    '.nv-help-dd__opt:last-child{ border-bottom:0; }' +
    '.nv-help-dd__opt.is-selected{ background:#f2f2f2; font-weight:600; }' +
    '.nv-quick-links{ display:none; font-family: var(--nv-font-mono, ui-monospace, monospace); text-transform:uppercase;' +
      'font-size:1.2rem; letter-spacing:.04em; color:#fff; text-align:left; margin:0 0 10px; }' +   /* sits on the dark hero */
    '@media (max-width:767px){' +
      '.hs-sidebar .hs-sidebar-nav{ display:none !important; }' +
      '.nv-help-dd{ display:block; }' +
      '.nv-quick-links{ display:block; }' +
    '}';
  var st = document.createElement('style');
  st.id = 'nv-help';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  function dropdown(){
    var nav = document.querySelector('.hs-sidebar-nav');
    if (!nav || nav._nv) return;
    nav._nv = 1;
    var path = location.pathname.replace(/\/$/, '');
    var links = [...nav.querySelectorAll('a')].map(function(a){
      var href = a.getAttribute('href') || '';
      return { href: href, label: (a.textContent || '').replace(/\s+/g, ' ').trim(),
        active: /nav-link-active/.test(a.className) || href.replace(/\/$/, '') === path };   // category pages don't set the class
    });
    var current = links.filter(function(l){ return l.active; })[0];
    var dd = document.createElement('div');
    dd.className = 'nv-help-dd';
    dd.innerHTML =
      '<button type="button" class="nv-help-dd__toggle" aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="nv-help-dd__label">' + (current ? current.label : 'Browse by category') + '</span>' +
        '<span class="nv-help-dd__chev" aria-hidden="true" style="transform:rotate(90deg)"></span></button>' +
      '<div class="nv-help-dd__panel" role="listbox">' +
        links.map(function(l){ return '<button type="button" role="option" class="nv-help-dd__opt' + (l.active ? ' is-selected' : '') + '" data-href="' + l.href + '">' + l.label + '</button>'; }).join('') +
      '</div>';
    nav.parentElement.insertBefore(dd, nav);
    var tg = dd.querySelector('.nv-help-dd__toggle');
    var panel = dd.querySelector('.nv-help-dd__panel');
    // open/close driven by INLINE styles (state selectors proved unreliable in injected sheets here)
    function setOpen(open){
      dd.classList.toggle('is-open', open);
      tg.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open){
        panel.style.display = 'block';
        panel.style.opacity = '0';
        panel.style.transform = 'translateY(-6px)';
        panel.style.transition = 'opacity .2s ease, transform .2s ease';
        void panel.offsetHeight;
        panel.style.opacity = '1';
        panel.style.transform = 'translateY(0)';
      } else {
        panel.style.display = 'none';
        panel.style.opacity = ''; panel.style.transform = ''; panel.style.transition = '';
      }
      var ch = tg.querySelector('.nv-help-dd__chev');
      if (ch) ch.style.transform = open ? 'rotate(-90deg)' : 'rotate(90deg)';
    }
    tg.addEventListener('click', function(){ setOpen(!dd.classList.contains('is-open')); });
    document.addEventListener('click', function(e){ if (!dd.contains(e.target)) setOpen(false); });
    panel.addEventListener('click', function(e){
      var o = e.target.closest('.nv-help-dd__opt');
      if (o && o.getAttribute('data-href')) location.href = o.getAttribute('data-href');
    });
  }

  function quickLinks(){
    var ff = document.querySelector('.ffaq-faqs');
    if (!ff || ff._nv) return;
    ff._nv = 1;
    var d = document.createElement('div');
    d.className = 'nv-quick-links';
    d.textContent = 'Quick links';
    ff.parentElement.insertBefore(d, ff);
  }

  /* ===== (C) "Find your answer in three easy steps" — banner + 3-question wizard ===== */
  var MAP = [
    { label: 'Orders', intents: [
      { label: 'Placing an order', articles: [['How can I place an order?','how-can-i-place-an-order'],['Is there a minimum order value?','is-there-a-minimum-order-value'],['Are international orders accepted?','are-international-orders-also-accepted'],['What happens after I complete my order?','what-happens-after-i-complete-my-order']] },
      { label: 'Tracking my order', articles: [['How do I track my order?','how-do-i-track-my-order'],['How can I see the orders I’ve placed?','how-can-i-see-the-orders-ive-placed']] },
      { label: 'Changing or cancelling', articles: [['How can I cancel an order?','how-can-i-cancel-an-order'],['Can I change the delivery address later?','can-i-later-change-the-delivery-address-for-an-already-confirmed-order']] },
      { label: 'Item out of stock', articles: [['What if the item I want is out of stock?','what-do-i-do-if-the-item-i-want-is-currently-not-in-stock']] }
    ]},
    { label: 'Shipping & delivery', intents: [
      { label: 'Shipping costs', articles: [['What are the shipping costs?','what-are-the-shipping-costs'],['What’s your shipping policy?','whats-your-shipping-policy']] },
      { label: 'Delivery time', articles: [['What is the delivery time?','what-is-the-delivery-time'],['How long until my order ships?','how-much-time-does-it-take-to-process-my-order-and-ship-it']] },
      { label: 'Tracking', articles: [['How can I track my order?','how-can-i-track-my-order'],['Did my order go through correctly?','how-can-i-be-sure-that-ive-placed-the-order-correctly']] },
      { label: 'Countries & couriers', articles: [['What countries do you ship to?','what-countries-do-you-currently-ship-to'],['Which couriers deliver my package?','which-delivery-companies-will-the-package-be-shipped-through']] },
      { label: 'Change my address', articles: [['Can I change the delivery address?','can-i-change-the-delivery-address-after-placing-the-order']] }
    ]},
    { label: 'Returns & refunds', intents: [
      { label: 'Start a return', articles: [['How do I return an item?','how-do-i-return-an-item']] },
      { label: 'Refund timing', articles: [['How long until I get my money back?','how-long-does-it-usually-take-to-get-my-money-back-for-a-return'],['How do I get my money back?','how-do-i-get-my-money-back']] },
      { label: 'Return costs', articles: [['Do I have to pay for the return?','do-i-have-to-pay-for-the-return'],['Is the shipping cost refunded too?','will-the-shipping-cost-be-refunded-after-i-return-the-order']] }
    ]},
    { label: 'Payments', intents: [
      { label: 'Payment methods', articles: [['What payment methods are accepted?','what-payment-methods-are-accepted']] },
      { label: 'Pay in installments', articles: [['How can I pay in installments?','how-can-i-pay-in-installments']] },
      { label: 'Invoices', articles: [['When will I receive my invoice?','when-and-how-will-i-receive-my-invoice']] }
    ]},
    { label: 'My account', intents: [
      { label: 'Creating an account', articles: [['How can I register?','how-can-i-register'],['Do I need an account to buy?','to-be-able-to-buy-from-the-website-do-i-need-to-create-an-account'],['Does registering cost anything?','does-registering-on-the-website-involve-any-costs']] },
      { label: 'Password', articles: [['Change or reset my password','how-can-i-change-my-password-or-how-can-i-change-my-forgotten-password']] },
      { label: 'Deleting my account', articles: [['How can I delete my account?','how-can-i-delete-my-customer-account']] }
    ]},
    { label: 'Discounts & vouchers', intents: [
      { label: 'Using a coupon', articles: [['How do I apply a coupon?','how-do-i-apply-a-coupon'],['What products work with my coupon?','what-products-are-compatible-with-my-coupon']] },
      { label: 'Finding coupons', articles: [['What coupons are available?','how-can-i-see-what-coupons-are-available'],['What are coupons?','what-are-coupons']] },
      { label: 'Sales', articles: [['Do you run any sales?','do-you-run-any-sales']] }
    ]},
    { label: 'Sizing & other', intents: [
      { label: 'Finding my size', articles: [['How do I find the right size?','how-do-i-find-the-right-size']] },
      { label: 'NO Points', articles: [['How does the point system work?','how-does-the-point-system-work']] },
      { label: 'Gift cards', articles: [['E-gift card','gift-card']] },
      { label: 'Newsletter', articles: [['How can I subscribe to the newsletter?','how-can-i-subscribe-to-the-newsletter']] }
    ]}
  ];

  var CHEV = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M9.5 7L14.5 12L9.5 17' stroke='black' stroke-width='1'/%3E%3C/svg%3E\")";
  var WCSS =
    '.nv-wizard-banner{ margin:18px auto 0; background:#141416; color:#fff; border-radius:12px; padding:26px 28px;' +
      'display:flex; align-items:center; justify-content:space-between; gap:16px; box-sizing:border-box; }' +
    '.nv-wizard-banner__title{ font-size:2rem; font-weight:500; }' +
    '.nv-wizard-banner__eyebrow{ font-family:var(--nv-font-mono, ui-monospace, monospace); text-transform:uppercase; font-size:1.1rem; opacity:.7; display:block; margin-bottom:5px; }' +
    '.nv-wizard-banner__btn{ flex:0 0 auto; background:#fff; color:#141416; border:0; border-radius:3.5px; padding:14px 28px;' +
      'font-size:1.4rem; font-weight:600; cursor:pointer; }' +
    '@media (max-width:767px){ .nv-wizard-banner{ flex-direction:column; align-items:flex-start; } .nv-wizard-banner__btn{ width:100%; } }' +
    '.nv-wizard-overlay{ position:fixed; inset:0; background:rgba(20,20,22,.45); z-index:9000; opacity:0; visibility:hidden; transition:opacity .3s ease; }' +
    '.nv-wizard-overlay.is-open{ opacity:1; visibility:visible; }' +
    '.nv-wizard{ position:fixed; z-index:9001; left:50%; top:50%; transform:translate(-50%, calc(-50% + 36px)); width:min(640px, calc(100vw - 32px));' +
      'background:#fff; color:#141416; border-radius:14px; padding:30px 28px 24px; opacity:0; visibility:hidden; overflow:hidden;' +
      'transition:opacity .3s ease, transform .35s cubic-bezier(.32,.72,0,1), height .3s ease; }' +
    '.nv-wizard.is-open{ opacity:1; visibility:visible; transform:translate(-50%,-50%); }' +
    '@media (max-width:767px){ .nv-wizard{ top:auto; bottom:0; left:0; transform:translateY(100%); width:100%; border-radius:16px 16px 0 0;' +
      'max-height:86dvh; overflow-y:auto; padding:26px 16px calc(20px + env(safe-area-inset-bottom)); }' +
      '.nv-wizard.is-open{ transform:translateY(0); } }' +
    '.nv-wizard__bar{ position:absolute; top:0; left:0; right:0; height:3px; background:rgba(20,20,22,.08); }' +
    '.nv-wizard__bar-fill{ height:100%; background:#141416; width:0; transition:width .35s ease; }' +
    '.nv-wizard__pane{ }' +
    '.nv-wizard__pane.is-entering{ animation:nvwSlide .28s ease both; }' +
    '@keyframes nvwSlide{ from{ opacity:0; transform:translateX(26px); } to{ opacity:1; transform:translateX(0); } }' +
    '.nv-wizard__step-label{ font-family:var(--nv-font-mono, ui-monospace, monospace); text-transform:uppercase; font-size:1.1rem; opacity:.55; margin-bottom:8px; }' +
    '.nv-wizard__q{ font-size:2.2rem; font-weight:600; margin:0 0 18px; letter-spacing:-.01em; }' +
    '.nv-wizard__opts{ display:flex; flex-direction:column; gap:9px; max-height:46dvh; overflow-y:auto; }' +
    '.nv-wizard__opt{ display:flex; align-items:center; justify-content:space-between; gap:12px; text-align:left; width:100%; background:#fff;' +
      'border:1px solid rgba(0,0,0,.12); border-radius:10px; padding:16px 18px; font-size:1.5rem; cursor:pointer;' +
      'transition:border-color .15s ease, background-color .15s ease; }' +
    '.nv-wizard__opt::after{ content:""; flex:0 0 auto; width:1.8rem; height:1.8rem; background-color:currentColor;' +
      '-webkit-mask:' + CHEV + ' center/contain no-repeat; mask:' + CHEV + ' center/contain no-repeat; opacity:.55; }' +
    '.nv-wizard__opt:hover{ border-color:#141416; }' +
    '.nv-wizard__opt.is-selected{ border-color:#141416; background:#f7f7f7; }' +
    '.nv-wizard__opt.is-selected::after{ opacity:1; }' +
    '.nv-wizard__result{ display:flex; align-items:center; justify-content:space-between; gap:12px; width:100%; box-sizing:border-box;' +
      'border:1px solid rgba(0,0,0,.12); border-radius:10px; padding:17px 18px; font-size:1.5rem; font-weight:500; color:#141416;' +
      'text-decoration:none; transition:border-color .15s ease, background-color .15s ease; }' +
    '.nv-wizard__result::after{ content:""; flex:0 0 auto; width:1.8rem; height:1.8rem; background-color:currentColor;' +
      '-webkit-mask:' + CHEV + ' center/contain no-repeat; mask:' + CHEV + ' center/contain no-repeat; }' +
    '.nv-wizard__result:hover{ border-color:#141416; background:#f7f7f7; }' +
    '.nv-wizard__success-eyebrow{ font-family:var(--nv-font-mono, ui-monospace, monospace); text-transform:uppercase; font-size:1.1rem; color:#1a7f37; margin-bottom:8px; }' +
    '.nv-wizard__footer{ display:flex; align-items:center; justify-content:space-between; margin-top:20px; gap:12px; }' +
    '.nv-wizard__back, .nv-wizard__again{ background:none; border:0; font-size:1.35rem; cursor:pointer; text-decoration:underline; text-underline-offset:3px; color:#141416; }' +
    '.nv-wizard__next{ background:#141416; color:#fff; border:0; border-radius:3.5px; padding:14px 28px; font-size:1.4rem; font-weight:600; cursor:pointer; }' +
    '.nv-wizard__next[disabled]{ opacity:.35; cursor:default; }' +
    '.nv-wizard__close{ position:absolute; top:14px; right:14px; width:34px; height:34px; background:#fff; border:1px solid rgba(0,0,0,.15);' +
      'border-radius:9px; cursor:pointer; font-size:1.4rem; line-height:1; color:#141416; z-index:2; }' +
    '.nv-wizard__close:hover{ border-color:#141416; }';

  function wizard(){
    var host = document.querySelector('.ffaq-main');
    var anchor = host && host.querySelector('.ffaq-faqs');
    if (!host || !anchor || document.querySelector('.nv-wizard-banner')) return;
    var s = document.createElement('style'); s.textContent = WCSS; document.head.appendChild(s);

    var banner = document.createElement('div');
    banner.className = 'nv-wizard-banner';
    banner.innerHTML = '<div><span class="nv-wizard-banner__eyebrow">Help wizard</span>' +
      '<div class="nv-wizard-banner__title">Find your answer in three easy steps</div></div>' +
      '<button type="button" class="nv-wizard-banner__btn">Get started</button>';
    anchor.parentElement.insertBefore(banner, anchor.nextElementSibling);
    // match the quick-links row width exactly (it has its own max-width)
    function sizeBanner(){ var r = anchor.getBoundingClientRect(); if (r.width > 0) banner.style.maxWidth = Math.round(r.width) + 'px'; }
    sizeBanner();
    window.addEventListener('resize', sizeBanner, { passive: true });

    var overlay = document.createElement('div'); overlay.className = 'nv-wizard-overlay';
    var modal = document.createElement('div'); modal.className = 'nv-wizard';
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
    document.body.appendChild(overlay); document.body.appendChild(modal);

    var state = { step: 1, topic: null, intent: null };
    function close(){ overlay.classList.remove('is-open'); modal.classList.remove('is-open'); }
    function open(){ state = { step: 1, topic: null, intent: null }; render(false); overlay.classList.add('is-open'); modal.classList.add('is-open'); modal.style.height = ''; }
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
    banner.querySelector('button').addEventListener('click', open);

    // delegated controls — survive every re-render
    modal.addEventListener('click', function(e){
      if (e.target.closest('.nv-wizard__close')){ close(); return; }
      if (e.target.closest('.nv-wizard__again')){ state = { step: 1, topic: null, intent: null }; render(true); return; }
      var back = e.target.closest('.nv-wizard__back');
      if (back){ state.step--; if (state.step === 1) state.intent = null; render(true); return; }
      var opt = e.target.closest('.nv-wizard__opt');
      if (opt){
        var i = parseInt(opt.getAttribute('data-i'), 10);
        if (state.step === 1){ state.topic = i; state.intent = null; }
        else { state.intent = i; }
        render(false, true);   // re-render selection only, no slide
        return;
      }
      if (e.target.closest('.nv-wizard__next')){
        if (state.step === 1 && state.topic != null){ state.step = 2; render(true); }
        else if (state.step === 2 && state.intent != null){ state.step = 3; render(true); }
      }
    });

    function paneHTML(){
      var fill = Math.round(state.step / 3 * 100);
      var head = '<button type="button" class="nv-wizard__close" aria-label="Close">✕</button>' +
        '<div class="nv-wizard__bar"><div class="nv-wizard__bar-fill" style="width:' + fill + '%"></div></div>';
      var body;
      if (state.step === 1){
        body = '<div class="nv-wizard__step-label">Step 1 of 3</div>' +
          '<h3 class="nv-wizard__q">What do you need help with?</h3><div class="nv-wizard__opts">' +
          MAP.map(function(t, i){ return '<button type="button" class="nv-wizard__opt' + (state.topic === i ? ' is-selected' : '') + '" data-i="' + i + '">' + t.label + '</button>'; }).join('') +
          '</div><div class="nv-wizard__footer"><span></span>' +
          '<button type="button" class="nv-wizard__next"' + (state.topic == null ? ' disabled' : '') + '>Next</button></div>';
      } else if (state.step === 2){
        body = '<div class="nv-wizard__step-label">Step 2 of 3</div>' +
          '<h3 class="nv-wizard__q">What about ' + MAP[state.topic].label.toLowerCase() + '?</h3><div class="nv-wizard__opts">' +
          MAP[state.topic].intents.map(function(it, i){ return '<button type="button" class="nv-wizard__opt' + (state.intent === i ? ' is-selected' : '') + '" data-i="' + i + '">' + it.label + '</button>'; }).join('') +
          '</div><div class="nv-wizard__footer">' +
          '<button type="button" class="nv-wizard__back">Back</button>' +
          '<button type="button" class="nv-wizard__next"' + (state.intent == null ? ' disabled' : '') + '>Next</button></div>';
      } else {
        var arts = MAP[state.topic].intents[state.intent].articles;
        body = '<div class="nv-wizard__success-eyebrow">✓ Found ' + (arts.length === 1 ? 'your answer' : arts.length + ' answers') + '</div>' +
          '<h3 class="nv-wizard__q">' + (arts.length === 1 ? 'This should cover it:' : 'These should cover it:') + '</h3>' +
          '<div class="nv-wizard__opts">' +
          arts.map(function(a){ return '<a class="nv-wizard__result" href="/pages/help/' + a[1] + '">' + a[0] + '</a>'; }).join('') +
          '</div><div class="nv-wizard__footer">' +
          '<button type="button" class="nv-wizard__again">Try again</button><span></span></div>';
      }
      return head + '<div class="nv-wizard__pane is-entering">' + body + '</div>';
    }

    function render(slide, keepHeight){
      var h0 = modal.offsetHeight;
      modal.innerHTML = paneHTML();
      if (!slide){ var p = modal.querySelector('.nv-wizard__pane'); if (p && keepHeight) p.classList.remove('is-entering'); return; }
      // animate the container height between steps
      modal.style.height = 'auto';
      var h1 = modal.offsetHeight;
      if (h0 && h1 && h0 !== h1){
        modal.style.height = h0 + 'px';
        void modal.offsetHeight;
        modal.style.height = h1 + 'px';
        setTimeout(function(){ modal.style.height = ''; }, 320);
      } else {
        modal.style.height = '';
      }
    }
  }

  /* ===== (D) Help contact area → accordions on MOBILE (built always; CSS gates per
     breakpoint so a desktop-width load, cache, or resize can never strand a phone). ===== */
  function accordions(){
    if (!document.getElementById('nv-help-acc-css')){
      var a = document.createElement('style'); a.id = 'nv-help-acc-css';
      a.textContent =
        '@media (max-width:767px){' +
          /* collapsed block hugs its header — kill the section's own tall padding/height */
          '.nv-acc{ padding:18px 16px !important; min-height:0 !important; height:auto !important; }' +
          '.nv-acc__head{ display:flex; align-items:center; justify-content:space-between; gap:12px; width:100%;' +
            'background:none; border:0; padding:0; margin:0; font-size:1.7rem; font-weight:600; color:inherit; cursor:pointer; text-align:left; }' +
          '.nv-acc__chev{ flex:0 0 auto; width:2.4rem; height:2.4rem; background-color:currentColor; display:inline-block;' +
            '-webkit-mask:' + CHEV + ' center/contain no-repeat; mask:' + CHEV + ' center/contain no-repeat;' +
            'transition:transform .25s ease; }' +
          '.nv-acc__hl{ display:flex; align-items:center; gap:10px; min-width:0; }' +
          '.nv-acc__hl svg{ width:2rem; height:2rem; flex:0 0 auto; }' +
          '.nv-acc__body .btn{ margin-top:12px !important; }' +
          '.nv-acc__body{ display:none; overflow:hidden; margin:0; }' +
          '.nv-acc__body > *:first-child{ margin-top:0 !important; }' +
          '.nv-acc__body .nv-acc__dup{ display:none !important; }' +
        '}' +
        '@media (min-width:768px){' +
          '.nv-acc__head{ display:none !important; }' +                 /* desktop keeps its original look */
          '.nv-acc__body{ max-height:none !important; overflow:visible !important; }' +
        '}';
      document.head.appendChild(a);
    }
    [['.help-more_item.is-highlighted.reqs-flex-third', 'Contact us by phone'],
     ['.reqs-second-flex-box', 'Get help']].forEach(function(cfg){
      var block = document.querySelector(cfg[0]);
      if (!block || block._nvAcc) return;
      block._nvAcc = 1;
      block.classList.add('nv-acc');
      var body = document.createElement('div'); body.className = 'nv-acc__body';
      while (block.firstChild) body.appendChild(block.firstChild);
      // the duplicated inner heading hides on mobile only (class, not inline style)
      var dup = [...body.querySelectorAll('*')].find(function(e){ return e.children.length === 0 && (e.textContent||'').trim().toLowerCase() === cfg[1].toLowerCase(); });
      if (dup) dup.classList.add('nv-acc__dup');
      var head = document.createElement('button');
      head.type = 'button'; head.className = 'nv-acc__head';
      var icon = body.querySelector('.chatbox-subtitle-header svg') || body.querySelector('.icon-1x1-small svg, svg.icon');
      head.innerHTML = '<span class="nv-acc__hl">' + (icon ? icon.outerHTML : '') + '<span>' + cfg[1] + '</span></span>' +
        '<span class="nv-acc__chev" aria-hidden="true" style="transform:rotate(90deg)"></span>';
      head.setAttribute('aria-expanded', 'false');
      head.addEventListener('click', function(){
        // fully inline-driven open/close (display + faded entrance) — immune to sheet state
        var open = block.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open){
          body.style.display = 'block';
          body.style.marginTop = '14px';
          body.style.opacity = '0';
          body.style.transition = 'opacity .25s ease';
          void body.offsetHeight;
          body.style.opacity = '1';
        } else {
          body.style.display = 'none';
          body.style.marginTop = '0px';
          body.style.opacity = '';
          body.style.transition = '';
        }
        var ch = head.querySelector('.nv-acc__chev');
        if (ch) ch.style.transform = open ? 'rotate(-90deg)' : 'rotate(90deg)';
      });
      block.appendChild(head);    // block was emptied above — head first, then body
      block.appendChild(body);
    });
  }

  function boot(){ dropdown(); quickLinks(); wizard(); accordions(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
